import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import StoresByBookingPage from '@/pages/StoresByBookingPage';

const StoresByBooking: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <StoresByBookingPage {...pageProps} />
};

export default StoresByBooking;
